import { useNicheCardListModel } from './niche-card-list.model'
import type { INicheCardListBase } from './niche-card-list.types'
import { NicheCardListView } from './niche-card-list.view'

export const NicheCardList = (props: INicheCardListBase) => {
  const nicheCardListModel = useNicheCardListModel(props)
  return <NicheCardListView {...props} {...nicheCardListModel} />
}
